import { Box, TextField, TextFieldProps } from '@mui/material';
import React from 'react';

////////////////////////////////////////////////////////////////////////////

interface IProps {
    renderInput: () => React.ReactNode[];
    actionButton: React.ReactNode;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Componente de Input, baseado no TextField,
 * que exibe um botão de ação para seleção de dados.
 *  
 * @param props
 */
export const MprcTextFieldAction = (props: IProps & Omit<TextFieldProps, "InputProps" | "inputProps">) => {

    const { renderInput, actionButton, ...rest } = props;

    return (
        <TextField
            {...rest}
            slotProps={{
                input: {
                    sx: { flexWrap: "wrap", paddingRight: "30px" },
                    readOnly: true,
                    startAdornment: renderInput(),
                    endAdornment: (
                        <Box sx={(theme) => ({ position: "absolute", right: theme.spacing(-.5) })}>
                            {actionButton}
                        </Box>
                    ),
                    inputProps: {sx: { width: 0, minWidth: "30px", flexGrow: 1 } }
                }
            }}
        />
    );
};
